import { gqlAccount, gqlCountry, gqlCurrencyEnum } from '@minecraft.graphql-types';
import { getCurrencyCodeLabel } from '@blocs.i18n';

interface PriceFormatParams {
  currencyCode?: gqlAccount['country']['currency']['code'] | gqlCurrencyEnum;
  countryCode?: gqlCountry['code'];
  price: number;
  t: (key: string, values: Record<string, string | number>) => string;
  noDecimal?: boolean;
  roundingFloor?: boolean;
}

export const priceFormatter = ({
  currencyCode = 'USD',
  countryCode = 'US',
  price,
  t,
  noDecimal = false,
  roundingFloor = false,
}: PriceFormatParams): string => {
  const displayedCurrencyCode = getCurrencyCodeLabel(currencyCode, countryCode);
  const translationKey = (() => {
    if (Number(price) < 0) {
      return 'common:paywall.currency.priceFormatNegative';
    }
    if (noDecimal) {
      return 'common:paywall.currency.priceFormatNoDecimal';
    }
    if (roundingFloor) {
      return 'common:paywall.currency.priceFormatRoundingFloor';
    }
    return 'common:paywall.currency.priceFormat';
  })();

  return t(translationKey, {
    currencyCode,
    price: Math.abs(price),
    displayedCurrencyCode,
  });
};
